import PdfBase from "../Schedules/Others/Pdf/PdfBase";
import ExcelBase from "../Schedules/Others/Excel/ExcelBase";
import generateMainCompPdf from "./Pdf/generateMainCompPdf";
import { IRAS_TABLE_SPACING_DISPLAY_PRESETS } from "./Pdf/iras/tableSpacing";

const PdfGenerator = ({
  company,
  currency,
  currencyRate,
  netProfitBeforeTax,
  referenceData,
  unutilisedCapitalAllowances,
  unutilisedLosses,
  currentYearLosses,
  unutilisedDonations,
  corporateIncomeTaxRebate,
  currentYearRebate,
  isStartup,
  taxPreviouslyAssessed,
  computedSummary,
  unabsorbedSummary,
  getUnabsorbedSummary,
  crossYAApportionmentContext,
  comments,
  reviewNote,
}) => {
  const resolveUnabsorbedSummary = () => {
    const computed =
      typeof getUnabsorbedSummary === "function"
        ? getUnabsorbedSummary()
        : unabsorbedSummary;

    return computed ?? { caRows: [], lossRows: [], donationRows: [] };
  };

  const canUseIrasPdfSettings = true;

  const generateDocument = (forView, isExcel = false, options = {}) => {
    const resolvedUnabsorbedSummary = resolveUnabsorbedSummary();
    const resolvedOptions =
      !isExcel && canUseIrasPdfSettings
        ? { ...options, pdfType: "iras" }
        : options;

    return generateMainCompPdf(
      forView,
      company,
      currency,
      currencyRate,
      netProfitBeforeTax,
      referenceData,
      unutilisedCapitalAllowances,
      unutilisedLosses,
      currentYearLosses,
      unutilisedDonations,
      corporateIncomeTaxRebate,
      currentYearRebate,
      isStartup,
      taxPreviouslyAssessed,
      computedSummary,
      resolvedUnabsorbedSummary,
      crossYAApportionmentContext,
      comments,
      reviewNote,
      isExcel,
      resolvedOptions
    );
  };

  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView, options) =>
          generateDocument(forView, false, options)
        }
        downloadName='Main Tax Computation'
        enableDraftView={true}
        pdfDensityOptions={
          canUseIrasPdfSettings
            ? {
                defaultValue: "default",
                options: [
                  { value: "default", label: "Default" },
                  { value: "compact", label: "Compact" },
                ],
              }
            : undefined
        }
        pdfSpacingPresets={
          canUseIrasPdfSettings ? IRAS_TABLE_SPACING_DISPLAY_PRESETS : undefined
        }
      />
      <ExcelBase generateExcel={(forView) => generateDocument(forView, true)} />
    </>
  );
};

export default PdfGenerator;
